<div class="row grid">
    <app-custom-table class="ag-theme-material" [rowData]="rowData" [showLoader]="showLoader" [columnDefs]="columnDefs"
        [defaultExcelExportParams]="defaultExcelExportParams" [defaultCsvExportParams]="defaultCsvExportParams"
        [animateRows]="true">
    </app-custom-table>
</div>